import React from 'react'
import { HeaderProps } from '@at/design-system-collections/'
import { ConnectedHeader } from '@at/connected-header'
import { useChannel } from './hooks/use-abtest.hook'

const ATHeader = (props: HeaderProps) => {
    const channel = useChannel()
    return <ConnectedHeader legacyMargins={false} searchOnClick={() => {}} {...props} channel={channel} />
}

export { ATHeader as Header }
